export default "__VITE_PUBLIC_ASSET__134bbd98__"